import { GetApp } from "../App"
import { classNames } from "../Components"
import { AppView } from "./AppView"
import { LoginView } from "./LoginView"
import { Session } from "../App/Session"

interface RootViewProps {
}

export function RootView(_: RootViewProps) {
  const app = GetApp()!;
  const route = app.getRoute();
  const isShipInvitationPath = route.route?.[0] == "ships" && route.route?.[1] == "invitation";
  // An enabled ship-invitation link must render LoginView even for an authorized
  // session so its already-logged-in accept UI remains reachable.
  const isShipInvitationRoute = app.hasFeature("multi-user") && isShipInvitationPath;
  // Let AppView's ordinary index-route redirect choose the account or current
  // ship instead of interpreting "invitation" as a numeric ship id.
  const appRoute = isShipInvitationPath && !isShipInvitationRoute ? { ...route, route: [] } : route;
  const isNativeLoginRoute = app.cloudSession() && route.route?.length == 1 && route.route[0] == "native-login";
  const isCompanionRoute = !app.cloudSession() && Session.isCompanionRoute(`/app/${route.route?.join("/")}`);

  return (
    <div className={classNames(["RootView", ...(app.appStyles.map((s) => `app-style-${s}`))])}>
      {app.session?.authorized && !isShipInvitationRoute && !isNativeLoginRoute && !isCompanionRoute ? <AppView route={appRoute} /> : (
        <>
          <LoginView />
        </>
      )}
    </div>
  );
}
